import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatName } from '../formatName';
import MyImageComponent from '../getImagePath';
import InfiniteScroll from 'react-infinite-scroll-component';
import '../App.css';

export const Home = () => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['Frames'],
        queryFn: async () => {
            try {
                const response = await fetch('https://raw.githubusercontent.com/toottootx/BGBerry-JSONs/main/sortedFrames.json');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return await response.json();
            } catch (error) {
                throw error;
            }
        }
    });

    const [visibleItems, setVisibleItems] = useState(20);
    const [filters, setFilters] = useState([]);
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [searchName, setSearchName] = useState('');

    const fetchMoreData = () => {
        setVisibleItems(prev => prev + 30);
    };

    const handleFilterChange = (event) => {
        const { value, checked } = event.target;
        setFilters(prevFilters => 
            checked ? [...prevFilters, value] : prevFilters.filter(filter => filter !== value)
        );
        setVisibleItems(50);
    };

    const handlePriceChange = (event) => {
        const { name, value } = event.target;
        if (name === 'minPrice') {
            setMinPrice(value);
        } else {
            setMaxPrice(value);
        }
        setVisibleItems(50);
    };

    const handleSearchName = (event) => {
        setSearchName(event.target.value);
        setVisibleItems(50);
    };

    const filteredData = data && Object.entries(data).filter(([name, item]) => {
        const matchesTags = filters.length === 0 || (item.tags && filters.every(filter => item.tags.includes(filter)));
        const matchesMinPrice = minPrice === '' || item.low >= parseFloat(minPrice);
        const matchesMaxPrice = maxPrice === '' || item.high <= parseFloat(maxPrice);
        const matchesName = searchName === '' || name.toLowerCase().includes(searchName.toLowerCase());
        return matchesTags && matchesMinPrice && matchesMaxPrice && matchesName;
    });

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const handleSidebarToggle = () => {
        setSidebarVisible(!sidebarVisible);
    };

    if (isLoading) return(
        <div className="fullscreen-container">
            <h1>Loading...</h1>
        </div>
    ); 
    if (isError) return(
        <div className="fullscreen-container">
            <h1>Error: {error.message}</h1>
        </div>
    )  

    const renderPrice = (name, low, high) => {
        return (
            <div className='prices-text'>
                <div className="low-price">Low: 🎟️{low}</div>
                <div className="high-price">High: 🎟️{high}</div>
            </div>
        );
    };


    return (
        <div className="container-fluid">
            <div className='filter-toggle' onClick={handleSidebarToggle}>
                <i className="fa-solid fa-filter"></i>
            </div>
            <div className="row">
                <aside className={`col-12 col-md-3 sidebar ${sidebarVisible ? 'd-block' : 'd-none d-md-block'} p-3 rounded`}
                    style={{ 
                        maxWidth: sidebarVisible ? '100%': '215px',
                        backgroundColor: "#2b2d31",
                        transition: 'max-width 0.3 ease',
                        
                        }}
                >
                    <h3 className='filter-title'>Filter</h3>
                    <form className='filterForm'>
                        <input
                            type="text"
                            id="searchName"
                            name="searchName"
                            value={searchName}
                            onChange={handleSearchName}
                            placeholder="Search Frame"
                            className=' form-control mb-2'
                        />

                        <input
                            type="number"
                            id="minPrice"
                            name="minPrice"
                            value={minPrice}
                            onChange={handlePriceChange}
                            placeholder="Min Price"
                            className=' form-control mb-2'
                        />

                        <input
                            type="number"
                            id="maxPrice"
                            name="maxPrice"
                            value={maxPrice}
                            onChange={handlePriceChange}
                            placeholder="Max Price"
                            className=' form-control mb-2'
                        />

                        <label>
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="transparent" name="transparent" value="transparent" />
                        <label htmlFor="transparent"> Transparent</label>
                        </div>
                        </label>

                        <label htmlFor="special">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="special" name="special" value="special" />
                        <label htmlFor="special"> Special</label>
                        </div>
                        </label>

                        <label htmlFor="carousel">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="carousel" name="carousel" value="carousel" />
                        <label htmlFor="carousel"> Carousel</label>
                        </div>
                        </label>

                        <label htmlFor="event">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="event" name="event" value="event" />
                        <label htmlFor="event"> Event</label>
                        </div>
                        </label>

                        <label htmlFor="bit">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="bit" name="bit" value="bit" />
                        <label htmlFor="bit"> Bit</label>
                        </div>
                        </label>

                        <label htmlFor="dojo">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="dojo" name="dojo" value="dojo" />
                        <label htmlFor="dojo"> Dojo</label>
                        </div>
                        </label>

                        <label htmlFor="monthly">
                        <div className='filterItemWrapper'>
                        <input className='filterItem' onChange={handleFilterChange} type="checkbox" id="monthly" name="monthly" value="monthly" />
                        <label htmlFor="monthly"> Monthly</label>
                        </div>
                        </label>

                    </form>
                </aside>
                

                <main className="col-md-9" id="infiniteScrollContainer"
                    style={{ flexGrow: 1 }}
                >
                    <InfiniteScroll
                        dataLength={visibleItems}
                        next={fetchMoreData}
                        hasMore={visibleItems < filteredData.length}
                        loader={<h4>Loading...</h4>}
                        scrollableTarget="infiniteScrollContainer"
                        className='scrollableArea'
                    >
                            {filteredData.slice(0, visibleItems).map(([name, { low, high }]) => {
                                return (
                                    <div key={name} className='scroll-item'>
                                        <h2 id='framename'>{formatName(name)}</h2>
                                        <div className="image-container">
                                            <MyImageComponent
                                            itemName={name} 
                                            />
                                        </div>
                                        {renderPrice(name, low, high)}
                                    </div>
                                );
                            })}
                    </InfiniteScroll>
                </main>

                <footer className=" col-12 text-center mt-2">
                    <nav className="nav justify-content-center">
                        <a className="nav-link text-white" href="/api">API</a>
                        <a className="nav-link text-white" href="https://guns.lol/toottoot" target="_blank" rel="noopener noreferrer">Contact</a>
                    </nav>
                </footer>
            </div>
        </div>
    );
}
